import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const policyListSlice = createApi({
    reducerPath: "policyList",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://policy-parsing.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        policyList: builder.query({
            query: (data) => ({ url: "/policy-inward/api/v1/policy/list", params: data, method: "GET" }),
        }),
    }),
});

export const { usePolicyListQuery } = policyListSlice;
